class Location < ApplicationRecord
  belongs_to :user
end
